var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTheme = function SvgTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.603.736a.446.446 0 1 0-.892 0V2.52a.446.446 0 1 0 .892 0zM11.603 19.48a.446.446 0 1 0-.892 0v1.785a.446.446 0 1 0 .892 0zM20.975 11.446a.446.446 0 1 0 0-.892H19.19a.446.446 0 1 0 0 .892zM2.231 11.446a.446.446 0 0 0 0-.892H.446a.446.446 0 1 0 0 .892zM16.458 4.621a.446.446 0 1 0 .631.631l1.263-1.262a.446.446 0 1 0-.631-.63zM17.72 18.64a.446.446 0 1 0 .632-.63l-1.262-1.263a.447.447 0 0 0-.632.632zM4.965 4.625a.446.446 0 0 1-.631.631L3.072 3.994a.446.446 0 1 1 .63-.631zM3.703 18.636a.446.446 0 1 1-.631-.63l1.262-1.263a.446.446 0 1 1 .631.631z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.19,
    d: "M10.71 16.802a5.802 5.802 0 1 0 0-11.604 5.802 5.802 0 0 0 0 11.604Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1.19,
    d: "M11.157 16.784V5.216a5.802 5.802 0 0 1 0 11.568Z",
    clipRule: "evenodd"
  })));
};
export default SvgTheme;